// ------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template.
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
// ------------------------------------------------------------------------------

import { Dictionary } from '../../../shared/models/dictionary.model';
import { IBaseType } from '../../../shared/enums/ibase-type.enum';

export interface IInsurancePolicyType {
    id: number;
    value: string;
    displayValue: string;
    description: string;
    isVehicle: boolean;
    sortOrder: number;
    active: boolean;
}

export class InsurancePolicyType implements IInsurancePolicyType, IBaseType {
    public id: number;
    public value: string;
    public displayValue: string;
    public description: string;
    public isVehicle: boolean;
    public sortOrder: number;
    public active: boolean;

    /**
		Returns Liability InsurancePolicyType
	**/
    get Liability(): IInsurancePolicyType {
        return this.FromId(1);
    }
    /**
		Returns Binder Policy InsurancePolicyType
	**/
    get BinderPolicy(): IInsurancePolicyType {
        return this.FromId(2);
    }
    /**
		Returns SR22 InsurancePolicyType
	**/
    get SR22(): IInsurancePolicyType {
        return this.FromId(3);
    }
    /**
		Returns Certificate of Deposit InsurancePolicyType
	**/
    get CertificateofDeposit(): IInsurancePolicyType {
        return this.FromId(4);
    }
    /**
		Returns Fleet Policy InsurancePolicyType
	**/
    get FleetPolicy(): IInsurancePolicyType {
        return this.FromId(5);
    }
    /**
		Returns Collectible Vehicle Insurance InsurancePolicyType
	**/
    get CollectibleVehicleInsurance(): IInsurancePolicyType {
        return this.FromId(6);
    }
    /**
		Returns Self Insurance InsurancePolicyType
	**/
    get SelfInsurance(): IInsurancePolicyType {
        return this.FromId(7);
    }
    /**
		Returns Military Insurance InsurancePolicyType
	**/
    get MilitaryInsurance(): IInsurancePolicyType {
        return this.FromId(8);
    }
    /**
		Returns Commercial Insurance InsurancePolicyType
	**/
    get CommercialInsurance(): IInsurancePolicyType {
        return this.FromId(9);
    }
    /**
		Returns Unknown InsurancePolicyType
	**/
    get Unknown(): IInsurancePolicyType {
        return this.FromId(10);
    }

    private _dictionary: Dictionary = new Dictionary([]);

    constructor() {
        this._dictionary.add('1', { id: 1, value: 'Liability', displayValue: 'Liability Vehicle Policy', description: 'Liability Vehicle Policy', isVehicle: true, sortOrder: 1, active: true });
        this._dictionary.add('2', { id: 2, value: 'BinderPolicy', displayValue: 'Binder Vehicle Policy', description: 'Binder Vehicle Policy', isVehicle: true, sortOrder: 3, active: true });
        this._dictionary.add('3', { id: 3, value: 'SR22', displayValue: 'SR22 Customer Policy', description: 'SR22 Customer Policy', isVehicle: false, sortOrder: 5, active: true });
        this._dictionary.add('4', { id: 4, value: 'CertificateofDeposit', displayValue: 'Certificate of Deposit Customer Policy', description: 'Certificate of Deposit Customer Policy', isVehicle: false, sortOrder: 7, active: true });
        this._dictionary.add('5', { id: 5, value: 'FleetPolicy', displayValue: 'Fleet Customer Policy', description: 'Fleet Customer Policy (Certificate of Insurance)', isVehicle: false, sortOrder: 9, active: true });
        this._dictionary.add('6', { id: 6, value: 'CollectibleVehicleInsurance', displayValue: 'Collectible Vehicle Policy', description: 'Collectible Vehicle Policy', isVehicle: true, sortOrder: 14, active: true });
        this._dictionary.add('7', { id: 7, value: 'SelfInsurance', displayValue: 'Self Insurance Customer Policy', description: 'Self Insurance Customer Policy', isVehicle: false, sortOrder: 10, active: true });
        this._dictionary.add('8', { id: 8, value: 'MilitaryVehicleInsurance', displayValue: 'Military Vehicle Insurance', description: 'Military Vehicle Insurance', isVehicle: true, sortOrder: 16, active: true });
        this._dictionary.add('9', { id: 9, value: 'CommercialInsurance', displayValue: 'Commercial Vehicle Policy', description: 'Commercial Vehicle Policy', isVehicle: true, sortOrder: 12, active: true });
        this._dictionary.add('10', { id: 10, value: 'Unknown', displayValue: 'Unknown', description: 'Unknown', isVehicle: true, sortOrder: 17, active: true });
        this._dictionary.add('11', { id: 11, value: 'LiabilityCustomer', displayValue: 'Liability Customer Policy', description: 'Liability Customer Policy', isVehicle: false, sortOrder: 2, active: true });
        this._dictionary.add('12', { id: 12, value: 'BinderPolicyCustomer', displayValue: 'Binder Customer Policy', description: 'Binder Customer Policy', isVehicle: false, sortOrder: 4, active: true });
        this._dictionary.add('13', { id: 13, value: 'CollectibleInsuranceCustomer', displayValue: 'Collectible Customer Policy', description: 'Collectible Customer Policy', isVehicle: false, sortOrder: 15, active: true });
        this._dictionary.add('14', { id: 14, value: 'CommercialCustomer', displayValue: 'Commercial Customer Policy', description: 'Commercial Customer Policy', isVehicle: false, sortOrder: 13, active: true });
        this._dictionary.add('15', { id: 15, value: 'IndividualSelfInsurance', displayValue: 'Individual Self Insurance Policy', description: 'Individual Self Insurance Policy', isVehicle: true, sortOrder: 11, active: true });
        this._dictionary.add('16', { id: 16, value: 'SR22Vehicle', displayValue: 'SR22 Vehicle Policy', description: 'SR22 Vehicle Policy', isVehicle: true, sortOrder: 6, active: true });
        this._dictionary.add('17', { id: 17, value: 'CertificateofDepositVehicle', displayValue: 'Certificate of Deposit Vehicle Policy', description: 'Certificate of Deposit Vehicle Policy', isVehicle: true, sortOrder: 8, active: true });
        this._dictionary.add('18', { id: 18, value: 'CommercialSelfVehicleInsurance', displayValue: 'Commercial Self Insurance Vehicle Policy', description: 'Commercial Self Insurance Vehicle Policy', isVehicle: true, sortOrder: 8, active: true });
        this._dictionary.add('19', { id: 19, value: 'MilitaryCustomerInsurance', displayValue: 'Military Customer Insurance', description: 'Military Customer Insurance', isVehicle: false, sortOrder: 19, active: true });
        this._dictionary.add('20', { id: 20, value: 'CommercialSelfCustomerInsurance', displayValue: 'Commercial Self Insurance Customer Policy', description: 'Commercial Self Insurance Customer Policy', isVehicle: false, sortOrder: 20, active: true });
    }

    public ToString(): string {
        return this.displayValue == null ? null : this.displayValue.toString();
    }

    public FromId(id: number): IInsurancePolicyType {
        return this._dictionary[id];
    }

    public FromValue(value: string): IInsurancePolicyType {
        var match = this._dictionary.getValues().filter(d => d.value == value);

        if (match.length > 0) {
            return this._dictionary[match[0].id];
        } else {
            return undefined;
        }
    }

    public GetAll(): IInsurancePolicyType[] {
        return this._dictionary.getValues().sort(this.sort_by('sortOrder', false, null, this.sort_by('displayValue', false, null, null)));
    }

    public GetActive(): IInsurancePolicyType[] {
        return this.GetAll().filter(d => d.active);
    }

    public Sort(primaryField, secondaryField, reverse): IInsurancePolicyType[] {
        return this.GetAll().sort(this.sort_by(primaryField, reverse, null, secondaryField != null ? this.sort_by(secondaryField, reverse, null, null) : null));
    }

    private sort_by = (path, reverse, primer, then) => {
        var get = (obj, path) => {
                if (path) {
                    path = path.split('.');

                    for (var i = 0, len = path.length - 1; i < len; i++) {
                        obj = obj[path[i]];
                    }

                    return obj[path[len]];
                }
                return obj;
            },
            prime = (obj) => primer ? primer(get(obj, path)) : get(obj, path);

        return (a, b) => {
            var A = prime(a),
                B = prime(b);

            return (
                (A < B) ? -1 :
                    (A > B) ? 1 :
                        (typeof then === 'function') ? then(a, b) : 0
            ) * [1, -1][+!!reverse];
        };
    };
}
